import { useNavigate } from 'react-router-dom';
import { getItem, getLocalizedPathFromLocalStorage } from '../../helper/localstorage.helper';
import React from 'react';

type FooterLink = {
    label: string;
    badge?: string;
    en?: string;
    sv?: string;
    url?: string;
};

interface FooterLinkListProps {
    title: string;
    links: FooterLink[];
    url?: string;
    onclick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, link: FooterLink) => void;
}

export const FooterLinkList: React.FC<FooterLinkListProps> = ({ title, links, onclick }) => {
    const navigate = useNavigate();
    return (
        <div>
            <h6 className="footer-title">{title}</h6>
            <ul className="footer-links">
                {links.map((item, idx) => (
                    <li key={item.label || idx} className="my-3 px-0">
                        {item.url === '/sitemap.xml' ? (
                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                {item.label}
                            </a>
                        ) : (
                            <a
                                href="#"
                                onClick={onclick
                                    ? (e) => onclick(e, item)
                                    : (e) => {
                                          e.preventDefault();
                                          if (item.en && item.sv) {
                                              navigate(
                                                  getLocalizedPathFromLocalStorage(
                                                      { get: (key: string) => getItem(key) ?? null },
                                                      {
                                                          'sv-se': item.sv,
                                                          'en-us': item.en
                                                      }
                                                  )
                                              );
                                          }
                                      }}
                            >
                                {item.label}
                            </a>
                        )}
                        {item.badge && <span className="badge mx-2">{item.badge}</span>}
                    </li>
                ))}
            </ul>
        </div>
    );
};
